// extracted by mini-css-extract-plugin
module.exports = {"dialogPopup":"PledgeAutoPopup_dialogPopup__K__b2","dialogBtn":"PledgeAutoPopup_dialogBtn__cVY7N"};